import { render, staticRenderFns } from "./AvatarSource.vue?vue&type=template&id=00727c5e"
import script from "./AvatarSource.vue?vue&type=script&lang=js"
export * from "./AvatarSource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports